import * as React from "react";
import { Container } from "react-bootstrap";

import Seo from "../components/Seo";
import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";
import PageHead from "../components/Page/PageHead";
import FaqAccordion from "../componentsSections/FaqAccordion";
import Hero from "../componentsSections/Hero";

import { faqPageTplData } from "../data/page-tpl-faq.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

const hasFaqItems = (section) =>
    section?.items?.some(
        (item) => item?.question?.trim() && item?.answer?.trim()
    );

const PageFaq = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = faqPageTplData(id);
    const faqSections = pageData.faqSections?.filter(hasFaqItems) || [];

    return (
        <Layout pageTitle={seoPageData.title}>
            <Seo post={seoPageData} />

            <Hero
                {...pageData.hero}
                textSize="big"
                className="-news -full-width-copy"
            />

            <Container>
                <PageHead {...pageData.pageHeader} className="-news" />
            </Container>

            {faqSections.map((faqSection, index) => (
                <Section
                    key={`faq-section-${index}`}
                    className="-mobile-full -faq-page-spacing"
                >
                    <FaqAccordion
                        {...faqSection}
                        id={index === 0 ? "faq" : `faq-${index + 1}`}
                    />
                </Section>
            ))}

            <PageFooterSections pageData={pageData} hideFaq />
        </Layout>
    );
};

export default PageFaq;
